import { type JSX } from 'preact';
import { navigateTo } from '../App';
import { AuthButton } from './AuthButton';
import { useTheme } from '../contexts/ThemeContext';

export function Header(): JSX.Element {
  const currentPath = window.location.pathname;
  const { theme, toggleTheme } = useTheme();

  const navItems = [
    { path: '/', label: 'One-Time Secrets' },
    { path: '/shamir/split', label: 'Split Secret' },
    { path: '/shamir/reconstruct', label: 'Reconstruct Secret' },
  ];

  const handleNavClick = (e: JSX.TargetedMouseEvent<HTMLAnchorElement>, path: string): void => {
    e.preventDefault();
    navigateTo(path);
  };

  return (
    <header className="bg-gray-900 dark:bg-gray-950 text-white transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold">Secure Secret Sharing</h1>
            <p className="text-gray-400 text-sm mt-1">Zero-knowledge cryptographic tools</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-800 dark:hover:bg-gray-900 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Toggle dark mode"
              title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
              {theme === 'light' ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              )}
            </button>
            <AuthButton />
          </div>
        </div>
        <nav className="mt-4 flex gap-4 border-t border-gray-700 pt-4">
          {navItems.map((item) => {
            // Special handling for One-Time Secrets: active on home AND retrieval pages
            const isActive = item.path === '/'
              ? currentPath === '/' || currentPath.startsWith('/secret/')
              : currentPath === item.path;

            return (
              <a
                key={item.path}
                href={item.path}
                onClick={(e) => handleNavClick(e, item.path)}
                className={`text-sm px-3 py-2 rounded transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-blue-600 text-white font-semibold'
                    : 'text-gray-300 hover:text-white hover:bg-gray-800'
                }`}
              >
                {item.label}
              </a>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
